
// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NumberComponent } from "./number.component";
import { FormFieldModule } from '../form-field/form-field.module';
import { FocusIfModule } from 'libraries/ui_toolbox/focus-if.module';
import { BlurIfModule } from 'libraries/directive/blur-If/blur-if.module';
import { NumberInputComponent } from './number-input.component';
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { IconNameToDefinitionModule } from "libraries/pipes/icon-name-to-definition/icon-name-to-definition.module";

@NgModule({
    imports: [
        CommonModule,
        FormFieldModule,
        FormsModule,
        ReactiveFormsModule,
        FocusIfModule,
        BlurIfModule,
        FontAwesomeModule,
        IconNameToDefinitionModule,
    ],
    declarations: [
        NumberComponent,
        NumberInputComponent,
    ],
    exports: [
        NumberComponent
    ]
})

export class NumberModule { }
